import { AGSSpinResponseSchema } from "ags/integration/schema/ags-spin-response-schema";
import { AGSSpinPublicStateSchema } from "ags/integration/schema/ags-spin-response-schema";
import gameiomModel from "gameiom/model/gameiom-model";
import { GameiomConfigSchema } from "gameiom/schema/gameiom-config-schema";
import BetModel from "slotworks/model/bets/bet-model";
import Gameplay from "slotworks/model/gameplay/gameplay";
import { RecordBuilder } from "slotworks/server/builders/record-builder";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import SmartUIManager from "slotworks/smart-ui/smart-ui-manager";

export abstract class AGSRecordBuilder implements RecordBuilder {

    public id: string = "AGSRecordBuilder";

    public abstract filter(request: any, response: any): boolean;

    public build(gameplay: Gameplay, request: any, response: any): any {
        const rootSpin = this.getRootAGSRecord(response);

        if (gameiomModel.currency === "TKN") {
            gameplay.balance = Math.round(rootSpin.platform.balance * 1);
        } else {
            gameplay.balance = Math.round(rootSpin.platform.balance * 100);
        }

        if (rootSpin.platform.balanceDetails) {
            const multiplier = (gameiomModel.currency === "TKN") ? 1 : 100;
            gameplay.realBalance = Math.round(rootSpin.platform.balanceDetails.real * multiplier);
            gameplay.freeBalance = Math.round(rootSpin.platform.balanceDetails.bonus * multiplier);
        } else {
            gameplay.realBalance = gameplay.balance;
            gameplay.freeBalance = 0;
        }
    }

    protected getRootAGSRecord(response: any): AGSSpinResponseSchema {
        return JSON.parse(response.data) as AGSSpinResponseSchema;
    }

    protected getLatestAGSSpin(rootState: AGSSpinPublicStateSchema) {
        let latestRecord = rootState.spin as any;

        while (latestRecord.childFeature && latestRecord.childFeature.length > 0) {
            latestRecord = latestRecord.childFeature[latestRecord.childFeature.length - 1];
        }

        return latestRecord;
    }
    protected isFreeBet(config: GameiomConfigSchema): boolean {
        return !!(config.forcedDenomination && config.forcedStake);
    }
    protected setCreditValues(config: GameiomConfigSchema) {
        const options = new ControlOptions();
        BetModel.injectBetOptions(options);
        if (BetModel.freeBet) {
            options.creditsPerLine.currentValue = config.forcedStake;
            options.creditSizes.currentValue = config.forcedDenomination;
        }
        BetModel.updateFromOptions(options);
        SmartUIManager.refresh();
    }
}
